import script from "./order.vue?vue&type=script&setup=true&lang=js"
export * from "./order.vue?vue&type=script&setup=true&lang=js"

import "./order.vue?vue&type=style&index=0&id=ee9c10c0&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9c10c0"]])

export default __exports__